import { Chips, FormField } from '@cian/ui-kit';
import React, { useEffect } from 'react';

import { IField } from '../../types/calculator';
import { useBaseField } from '../BaseField';

export const ChipsField: React.FC<IField> = props => {
  const { source = [], label, disabled, defaultValue } = props;
  const {
    field: { onChange, value },
    fieldState,
  } = useBaseField(props);

  useEffect(() => {
    if (defaultValue) {
      onChange(defaultValue);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isError = fieldState.isDirty || fieldState.invalid;

  const options = source.map(option => ({
    value: option.value,
    label: option.label,
    disabled: option.disabled || disabled,
  }));

  return (
    <FormField
      label={label}
      errorMessage={isError ? fieldState.error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <Chips options={options} value={[value]} onChipClick={value => onChange(value)} />
    </FormField>
  );
};

ChipsField.displayName = 'ChipsField';
